    (function () {
      if (window.JXSrcVidRecommendations && window.JXSrcVidRecommendations.ready && window.JXSrcVidRecommendations.version === 'v6.6') {
        window.JXSrcVidRecommendations.init(document);
        return;
      }

      var api = {
        ready: true,
        version: 'v6.6',
        variantCache: {},
        productCache: {},
        searchCache: {},
        observerStarted: false,
        observerTimer: null,

        root: function () {
          if (window.Shopify && Shopify.routes && Shopify.routes.root) {
            return Shopify.routes.root;
          }
          return '/';
        },

        getCartAddUrl: function () {
          if (window.routes && window.routes.cartAddUrl) {
            return window.routes.cartAddUrl + '.js';
          }
          return api.root() + 'cart/add.js';
        },

        variantUrl: function (variantId) {
          return api.root() + 'variants/' + encodeURIComponent(variantId) + '.js';
        },

        productJsonUrl: function (handle) {
          return api.root() + 'products/' + encodeURIComponent(handle) + '.js';
        },

        searchSuggestUrl: function (query) {
          return api.root() + 'search/suggest.json?q=' + encodeURIComponent(query || '') + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=show';
        },

        handleFromUrl: function (url) {
          if (!url) {
            return '';
          }
          var href = String(url).split('?')[0].split('#')[0];
          var match = href.match(/\/products\/([^\/]+)/);
          return match && match[1] ? decodeURIComponent(match[1]) : '';
        },

        productUrlFromVariant: function (variant) {
          if (variant.url) {
            return variant.url;
          }
          if (variant.product_handle) {
            return api.root() + 'products/' + variant.product_handle + '?variant=' + variant.id;
          }
          if (variant.handle) {
            return api.root() + 'products/' + variant.handle + '?variant=' + variant.id;
          }
          return '#';
        },

        priceToCents: function (price) {
          if (price == null || price === '') {
            return 0;
          }
          if (typeof price === 'number') {
            return Math.round(price);
          }
          var text = String(price).trim();
          var cleaned = text.replace(/[^0-9.,-]/g, '').replace(',', '.');
          var value = Number(cleaned);
          if (!isFinite(value)) {
            return 0;
          }
          if (text.indexOf('.') !== -1 || text.indexOf(',') !== -1) {
            return Math.round(value * 100);
          }
          return Math.round(value);
        },

        fetchVariant: function (variantId) {
          variantId = String(variantId || '').trim();
          if (!variantId) {
            return Promise.resolve(null);
          }
          if (api.variantCache[variantId]) {
            return api.variantCache[variantId];
          }
          api.variantCache[variantId] = fetch(api.variantUrl(variantId), { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('Variant JSON not found');
              }
              return response.json();
            })
            .then(function (variant) {
              return api.normalizeVariant(variant, variantId);
            })
            .catch(function () {
              return null;
            });
          return api.variantCache[variantId];
        },

        imageFrom: function (value) {
          if (!value) {
            return null;
          }
          if (typeof value === 'string') {
            return value;
          }
          return value.src || value.url || value.preview_image && (value.preview_image.src || value.preview_image.url) || null;
        },

        imageFromProductJson: function (product, variantId) {
          if (!product) {
            return null;
          }
          var variantImage = null;
          if (Array.isArray(product.variants)) {
            product.variants.some(function (variant) {
              if (String(variant.id) === String(variantId)) {
                variantImage = api.imageFrom(variant.featured_image) || api.imageFrom(variant.image);
                return true;
              }
              return false;
            });
          }
          return variantImage ||
            api.imageFrom(product.featured_image) ||
            api.imageFrom(product.image) ||
            (Array.isArray(product.images) && product.images.length ? api.imageFrom(product.images[0]) : null);
        },

        fetchProductByHandle: function (handle) {
          handle = String(handle || '').trim();
          if (!handle) {
            return Promise.resolve(null);
          }
          if (api.productCache[handle]) {
            return api.productCache[handle];
          }
          api.productCache[handle] = fetch(api.productJsonUrl(handle), { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('Product JSON not found');
              }
              return response.json();
            })
            .then(function (product) {
              if (product && !product.handle) {
                product.handle = handle;
              }
              if (product && !product.url) {
                product.url = api.root() + 'products/' + handle;
              }
              return product;
            })
            .catch(function () {
              return null;
            });
          return api.productCache[handle];
        },

        normalizeText: function (value) {
          return String(value || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ' ').trim();
        },

        productFromSuggest: function (product) {
          if (!product) {
            return null;
          }
          var handle = product.handle || api.handleFromUrl(product.url || product.url_with_params || '');
          var url = product.url || product.url_with_params || (handle ? api.root() + 'products/' + handle : '#');
          var image = api.imageFrom(product.image) || api.imageFrom(product.featured_image);
          return {
            handle: handle,
            title: product.title || '',
            url: url,
            image: image,
            raw: product
          };
        },

        chooseSuggestedProduct: function (products, title) {
          var wanted = api.normalizeText(title);
          var best = null;
          var bestScore = -1;
          (products || []).forEach(function (candidate) {
            var product = api.productFromSuggest(candidate);
            if (!product) {
              return;
            }
            var text = api.normalizeText(product.title);
            var score = 0;
            if (wanted && text === wanted) {
              score = 100;
            } else if (wanted && (text.indexOf(wanted) !== -1 || wanted.indexOf(text) !== -1)) {
              score = 80;
            } else if (wanted) {
              wanted.split(' ').forEach(function (token) {
                if (token.length > 2 && text.indexOf(token) !== -1) {
                  score += 3;
                }
              });
            }
            if (score > bestScore) {
              bestScore = score;
              best = product;
            }
          });
          return best;
        },

        searchProductByTitle: function (title) {
          title = String(title || '').replace(/\s+/g, ' ').trim();
          if (!title) {
            return Promise.resolve(null);
          }
          var cacheKey = api.normalizeText(title);
          if (api.searchCache[cacheKey]) {
            return api.searchCache[cacheKey];
          }
          api.searchCache[cacheKey] = fetch(api.searchSuggestUrl(title), { credentials: 'same-origin' })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('Search suggest failed');
              }
              return response.json();
            })
            .then(function (json) {
              var products = json && json.resources && json.resources.results && json.resources.results.products || json && json.products || [];
              return api.chooseSuggestedProduct(products, title);
            })
            .catch(function () {
              return null;
            });
          return api.searchCache[cacheKey];
        },

        rowDebug: function (root) {
          return Array.prototype.slice.call((root || document).querySelectorAll('.jx-srcvid-recommendations__item')).map(function (el, i) {
            var titleEl = el.querySelector('.jx-srcvid-recommendations__title');
            var imageLink = el.querySelector('.jx-srcvid-recommendations__image-link');
            var img = el.querySelector('img.jx-srcvid-recommendations__image, img');
            var placeholder = el.querySelector('.jx-srcvid-recommendations__image-placeholder');
            var variantNode = el.querySelector('[data-variant-id]');
            return {
              index: i + 1,
              variantId: el.getAttribute('data-jx-srcvid-variant-id') || el.getAttribute('data-jx-srcvid-item') || (variantNode && variantNode.getAttribute('data-variant-id')) || '',
              title: (titleEl && titleEl.textContent || el.textContent || '').trim().replace(/\s+/g, ' '),
              itemHref: titleEl && titleEl.getAttribute('href') || '',
              imageHref: imageLink && imageLink.getAttribute('href') || '',
              handle: el.getAttribute('data-jx-srcvid-product-handle') || api.handleFromUrl(imageLink && imageLink.getAttribute('href')) || api.handleFromUrl(titleEl && titleEl.getAttribute('href')) || '',
              hasImg: !!img,
              imgSrc: img && (img.currentSrc || img.src) || '',
              hasPlaceholder: !!placeholder,
              dataset: Object.assign({}, el.dataset)
            };
          });
        },

        copyDebug: function (root) {
          var result = api.rowDebug(root || document);
          try {
            console.table(result);
          } catch (error) {}
          try {
            copy(JSON.stringify(result, null, 2));
          } catch (error) {}
          return result;
        },

        makeImage: function (src, title) {
          var img = document.createElement('img');
          img.className = 'jx-srcvid-recommendations__image';
          img.src = src;
          img.alt = title || '';
          img.loading = 'lazy';
          img.width = 60;
          img.height = 60;
          return img;
        },

        normalizeVariant: function (variant, requestedId) {
          if (!variant) {
            return null;
          }
          var id = Number(variant.id || requestedId);
          var variantTitle = variant.public_title || variant.title || '';
          if (variantTitle === 'Default Title') {
            variantTitle = '';
          }

          var productTitle = variant.product_title || '';
          if (!productTitle && variant.name && variantTitle) {
            productTitle = String(variant.name).replace(' - ' + variantTitle, '');
          }
          if (!productTitle) {
            productTitle = variant.name || variant.title || '';
          }

          var imageSrc = api.imageFrom(variant.featured_image) ||
            api.imageFrom(variant.image) ||
            api.imageFrom(variant.featured_media) ||
            api.imageFrom(variant.product && (variant.product.featured_image || variant.product.image)) ||
            api.imageFrom(variant.featured_image && variant.featured_image.preview_image);

          return {
            id: id,
            product: {
              id: variant.product_id || null,
              title: productTitle,
              url: api.productUrlFromVariant(Object.assign({}, variant, { id: id })),
              image: imageSrc
            },
            variant: {
              id: id,
              title: variantTitle,
              available: variant.available !== false,
              price: api.priceToCents(variant.price),
              image: imageSrc
            }
          };
        },

        formatMoney: function (cents, format) {
          cents = Number(cents || 0);
          if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            try {
              return Shopify.formatMoney(cents, format || window.theme && window.theme.moneyFormat);
            } catch (error) {}
          }
          return (cents / 100).toLocaleString('sv-SE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' kr';
        },

        text: function (value) {
          return document.createTextNode(value == null ? '' : String(value));
        },

        label: function (template, title) {
          return String(template || '').replace('[title]', title || '');
        },

        renderRow: function (container, match, index) {
          var mode = container.getAttribute('data-jx-srcvid-mode') || 'product';
          var product = match.product;
          var variant = match.variant;
          var item = document.createElement('div');
          item.className = 'jx-srcvid-recommendations__item';
          item.setAttribute('data-jx-srcvid-item', variant.id || '');
          item.setAttribute('data-jx-srcvid-variant-id', variant.id || '');
          item.setAttribute('data-jx-srcvid-preferred-variant-id', variant.id || '');
          item._jxSrcvidProduct = match.fullProduct || null;
          if (match.fullProduct && match.fullProduct.id) {
            item.setAttribute('data-jx-srcvid-product-id', match.fullProduct.id);
          }
          if (product.url && product.url !== '#') {
            item.setAttribute('data-jx-srcvid-product-url', product.url);
            item.setAttribute('data-jx-srcvid-product-handle', api.handleFromUrl(product.url));
          }

          if (mode === 'product') {
            var label = document.createElement('label');
            label.className = 'jx-srcvid-recommendations__selector';
            label.setAttribute('aria-label', api.label(container.getAttribute('data-jx-srcvid-text-select'), product.title));

            var input = document.createElement('input');
            input.className = 'jx-srcvid-recommendations__checkbox';
            input.type = 'checkbox';
            input.setAttribute('data-jx-srcvid-checkbox', '');
            input.setAttribute('data-variant-id', variant.id);
            input.setAttribute('data-product-title', product.title || '');
            input.disabled = variant.available === false;
            if (!input.disabled && index < Number(container.getAttribute('data-jx-srcvid-preselected') || 0)) {
              input.checked = true;
            }

            var check = document.createElement('span');
            check.className = 'jx-srcvid-recommendations__checkmark';
            check.setAttribute('aria-hidden', 'true');
            check.innerHTML = '<svg viewBox="0 0 14 14" focusable="false" aria-hidden="true"><path d="M5.45 10.4 2.2 7.15l1.05-1.05 2.2 2.2 5.3-5.3 1.05 1.05z"/></svg>';
            label.appendChild(input);
            label.appendChild(check);
            item.appendChild(label);
          }

          var imageLink = document.createElement('a');
          imageLink.className = 'jx-srcvid-recommendations__image-link';
          imageLink.href = product.url || '#';
          imageLink.setAttribute('aria-label', product.title || '');
          if (product.url === '#') {
            imageLink.setAttribute('tabindex', '-1');
          }

          var imageSrc = variant.image || product.image;
          if (imageSrc) {
            imageLink.appendChild(api.makeImage(imageSrc, product.title));
          } else {
            var placeholder = document.createElement('span');
            placeholder.className = 'jx-srcvid-recommendations__image-placeholder';
            imageLink.appendChild(placeholder);
          }
          item.appendChild(imageLink);

          var details = document.createElement('div');
          details.className = 'jx-srcvid-recommendations__details';
          var title = document.createElement('a');
          title.className = 'jx-srcvid-recommendations__title';
          title.href = product.url || '#';
          if (product.url === '#') {
            title.setAttribute('tabindex', '-1');
          }
          title.appendChild(api.text(product.title || ''));
          details.appendChild(title);
          var options = document.createElement('div');
          options.className = 'jx-srcvid-recommendations__options';
          options.setAttribute('data-jx-srcvid-options', '');
          details.appendChild(options);
          item.appendChild(details);

          var price = document.createElement('div');
          price.className = 'jx-srcvid-recommendations__price';
          price.appendChild(api.text(api.formatMoney(variant.price, container.getAttribute('data-jx-srcvid-money-format'))));
          item.appendChild(price);

          if (mode === 'cart') {
            var add = document.createElement('button');
            add.type = 'button';
            add.className = 'jx-srcvid-recommendations__add';
            add.setAttribute('data-jx-srcvid-add', '');
            add.setAttribute('data-variant-id', variant.id);
            add.disabled = variant.available === false;
            add.setAttribute('aria-label', api.label(container.getAttribute('data-jx-srcvid-text-add'), product.title));
            add.innerHTML = '<span class="lhbutton_style" aria-hidden="true"><img src="https://cdn.shopify.com/s/files/1/0540/1762/2189/files/20260515104427_64_201.png?v=1778834887" width="12px" height="12px"></span>';
            item.appendChild(add);
          }

          return item;
        },

        variantOptions: function (variant, count) {
          if (Array.isArray(variant.options) && variant.options.length) {
            return variant.options.map(String);
          }
          var values = [];
          for (var i = 1; i <= count; i++) {
            values.push(String(variant['option' + i] || ''));
          }
          return values;
        },

        swatchStyle: function (row, name) {
          var definition = Array.prototype.slice.call(row.querySelectorAll('[data-jx-srcvid-swatch-name]')).find(function (node) {
            return node.getAttribute('data-jx-srcvid-swatch-name') === name;
          });
          var color = definition && definition.getAttribute('data-jx-srcvid-swatch-color');
          var image = definition && definition.getAttribute('data-jx-srcvid-swatch-image');
          if (!color && !image) {
            var known = {
              black: '#000000', white: '#ffffff', silver: '#c0c0c0', gray: '#808080', grey: '#808080',
              gold: '#d6bb80', blue: '#158be5', violet: '#d786e9', purple: '#8747a7',
              red: '#d93030', green: '#45945b', pink: '#efa9c7', orange: '#f68b38',
              yellow: '#f3d453', brown: '#8a5b3f', beige: '#d8c7a5', graphite: '#53565a',
              teal: '#5b9d98', blush: '#e8d3da', cloud: '#e8d3da',
              svart: '#000000', vit: '#ffffff', blå: '#158be5', grå: '#808080', grön: '#45945b',
              röd: '#d93030', rosa: '#efa9c7', lila: '#8747a7'
            };
            var normalized = String(name || '').toLowerCase();
            Object.keys(known).some(function (key) {
              if (normalized === key || normalized.indexOf(' ' + key) !== -1 || normalized.indexOf(key + ' ') === 0) {
                color = known[key];
                return true;
              }
              return false;
            });
            if (!color && window.CSS && CSS.supports && CSS.supports('color', name)) {
              color = name;
            }
          }
          return { color: color || '#d7dce0', image: image };
        },

        enhanceRowVariants: function (container, row, product) {
          if (!product || !Array.isArray(product.variants) || !product.variants.length || row.dataset.jxSrcvidVariantsReady === 'true') {
            return;
          }
          var variants = product.variants;
          var optionDefinitions = Array.isArray(product.options) ? product.options.map(function (option) {
            return typeof option === 'string' ? option : option.name || '';
          }) : [];
          var optionCount = optionDefinitions.length;
          if (!optionCount) {
            optionCount = variants[0].options && variants[0].options.length || 1;
            optionDefinitions = Array(optionCount).fill('Variant');
          }
          var colorIndex = optionDefinitions.findIndex(function (name) {
            return /(color|colour|färg|farge|farve|väri)/i.test(String(name).trim());
          });
          var preferredId = row.getAttribute('data-jx-srcvid-preferred-variant-id') || row.getAttribute('data-jx-srcvid-variant-id');
          var selectedVariant = variants.find(function (variant) { return String(variant.id) === String(preferredId) && variant.available; }) ||
            variants.find(function (variant) { return variant.available; });
          if (!selectedVariant) {
            if (api.linkedProductEntries(product).length < 2) row.hidden = true;
            return;
          }
          var selected = api.variantOptions(selectedVariant, optionCount);
          var optionsNode = row.querySelector('[data-jx-srcvid-options]');
          if (!optionsNode) {
            return;
          }
          optionsNode.innerHTML = '';
          var swatchButtons = [];
          var otherSelects = [];

          function matches(variant, values, skipIndex) {
            var candidate = api.variantOptions(variant, optionCount);
            return values.every(function (value, index) {
              return index === skipIndex || !value || candidate[index] === value;
            });
          }

          function updateRow(variant) {
            if (!variant || !variant.available) {
              return;
            }
            selectedVariant = variant;
            selected = api.variantOptions(variant, optionCount);
            row.setAttribute('data-jx-srcvid-variant-id', variant.id);
            row.setAttribute('data-jx-srcvid-item', variant.id);
            var action = row.querySelector('[data-jx-srcvid-checkbox], [data-jx-srcvid-add]');
            if (action) {
              action.setAttribute('data-variant-id', variant.id);
            }
            var skuImage = null;
            if (variant.sku && Array.isArray(product.images)) {
              skuImage = product.images.find(function (candidate) {
                var filename = String(api.imageFrom(candidate) || '').split('?')[0].split('/').pop();
                return filename && filename.replace(/\.[^.]+$/, '').toLowerCase() === String(variant.sku).toLowerCase();
              });
            }
            var image = api.imageFrom(variant.featured_image) || api.imageFrom(variant.image) || api.imageFrom(skuImage) || api.imageFrom(product.featured_image) ||
              (Array.isArray(product.images) && product.images.length ? api.imageFrom(product.images[0]) : null);
            var imageLink = row.querySelector('.jx-srcvid-recommendations__image-link');
            if (imageLink && image) {
              var currentImage = imageLink.querySelector('.jx-srcvid-recommendations__image');
              if (!currentImage) {
                imageLink.innerHTML = '';
                currentImage = api.makeImage(image, product.title);
                imageLink.appendChild(currentImage);
              }
              currentImage.removeAttribute('srcset');
              currentImage.src = image;
              currentImage.alt = product.title + (colorIndex >= 0 && selected[colorIndex] ? ' - ' + selected[colorIndex] : '');
            }
            var productUrl = row.getAttribute('data-jx-srcvid-product-url') || product.url || (product.handle ? api.root() + 'products/' + product.handle : '');
            if (productUrl && productUrl !== '#') {
              var variantUrl = productUrl.split('?')[0].split('#')[0] + '?variant=' + variant.id;
              row.querySelectorAll('.jx-srcvid-recommendations__image-link, .jx-srcvid-recommendations__title').forEach(function (link) {
                link.href = variantUrl;
                link.removeAttribute('tabindex');
              });
            }
            var price = row.querySelector('.jx-srcvid-recommendations__price');
            if (price) {
              price.textContent = api.formatMoney(variant.price, container.getAttribute('data-jx-srcvid-money-format'));
            }
            otherSelects.forEach(function (entry) { entry.node.value = selected[entry.index]; });
            swatchButtons.forEach(function (entry) {
              var candidateValues = selected.slice();
              candidateValues[colorIndex] = entry.value;
              var isAvailable = variants.some(function (candidate) { return candidate.available && matches(candidate, candidateValues, -1); });
              entry.node.disabled = !isAvailable;
              entry.node.setAttribute('aria-pressed', String(selected[colorIndex] === entry.value));
              entry.node.setAttribute('aria-label', entry.value + (isAvailable ? '' : ' - sold out'));
            });
          }

          if (colorIndex >= 0) {
            var swatches = document.createElement('div');
            swatches.className = 'jx-srcvid-recommendations__swatches';
            var colors = [];
            variants.forEach(function (variant) {
              var value = api.variantOptions(variant, optionCount)[colorIndex];
              if (value && colors.indexOf(value) === -1) {
                colors.push(value);
              }
            });
            colors.forEach(function (value) {
              var button = document.createElement('button');
              button.type = 'button';
              button.className = 'jx-srcvid-recommendations__swatch';
              button.title = value;
              var fill = document.createElement('span');
              fill.className = 'jx-srcvid-recommendations__swatch-fill';
              fill.setAttribute('aria-hidden', 'true');
              var style = api.swatchStyle(row, value);
              fill.style.setProperty('--jx-srcvid-swatch-color', style.color);
              if (style.image) {
                fill.style.setProperty('--jx-srcvid-swatch-image', 'url(' + JSON.stringify(style.image) + ')');
              }
              button.appendChild(fill);
              button.addEventListener('click', function () {
                var values = selected.slice();
                values[colorIndex] = value;
                var variant = variants.find(function (candidate) { return candidate.available && matches(candidate, values, -1); });
                if (variant) {
                  updateRow(variant);
                }
              });
              swatches.appendChild(button);
              swatchButtons.push({ node: button, value: value });
            });
            optionsNode.appendChild(swatches);
          }

          optionDefinitions.forEach(function (name, index) {
            if (index === colorIndex || variants.length === 1) {
              return;
            }
            var select = document.createElement('select');
            select.className = 'jx-srcvid-recommendations__other-option';
            select.setAttribute('aria-label', name);
            select.title = name;
            var values = [];
            variants.forEach(function (variant) {
              var value = api.variantOptions(variant, optionCount)[index];
              if (value && values.indexOf(value) === -1) {
                values.push(value);
              }
            });
            values.forEach(function (value) {
              var option = document.createElement('option');
              option.value = value;
              option.textContent = value;
              select.appendChild(option);
            });
            select.value = selected[index];
            select.addEventListener('change', function () {
              var values = selected.slice();
              values[index] = select.value;
              var variant = variants.find(function (candidate) { return candidate.available && matches(candidate, values, -1); }) ||
                variants.find(function (candidate) { return candidate.available && api.variantOptions(candidate, optionCount)[index] === select.value; });
              if (variant) {
                updateRow(variant);
              } else {
                select.value = selected[index];
              }
            });
            optionsNode.appendChild(select);
            otherSelects.push({ node: select, index: index });
          });
          row.dataset.jxSrcvidVariantsReady = 'true';
          updateRow(selectedVariant);
        },

        linkedProductEntries: function (product) {
          var tags = product && product.tags;
          if (!Array.isArray(tags)) {
            return [];
          }
          var tag = tags.find(function (value) { return /^options:parent:/i.test(String(value)); });
          if (!tag) {
            return [];
          }
          var seen = {};
          return String(tag).replace(/^options:parent:/i, '').replace(/;\s*$/, '').split('|').map(function (part) {
            var separator = part.indexOf(':');
            if (separator < 1) return null;
            var id = part.slice(0, separator).trim();
            var title = part.slice(separator + 1).trim();
            if (!/^\d+$/.test(id) || seen[id]) return null;
            seen[id] = true;
            return { id: id, title: title };
          }).filter(Boolean);
        },

        linkedColorNames: function (entries) {
          var titles = entries.map(function (entry) { return entry.title; });
          var prefix = titles[0] || '';
          var suffix = titles[0] || '';
          titles.slice(1).forEach(function (title) {
            while (prefix && title.indexOf(prefix) !== 0) prefix = prefix.slice(0, -1);
            while (suffix && title.slice(-suffix.length) !== suffix) suffix = suffix.slice(1);
          });
          prefix = prefix.slice(0, prefix.lastIndexOf(' ') + 1);
          if (suffix && suffix[0] !== ' ') suffix = suffix.indexOf(' ') >= 0 ? suffix.slice(suffix.indexOf(' ')) : '';
          return entries.map(function (entry) {
            var end = suffix ? entry.title.length - suffix.length : entry.title.length;
            return entry.title.slice(prefix.length, end).trim() || entry.title;
          });
        },

        imageForLinkedProduct: function (product, variant) {
          var skuImage = null;
          if (variant && variant.sku && Array.isArray(product.images)) {
            skuImage = product.images.find(function (candidate) {
              var filename = String(api.imageFrom(candidate) || '').split('?')[0].split('/').pop();
              return filename && filename.replace(/\.[^.]+$/, '').toLowerCase() === String(variant.sku).toLowerCase();
            });
          }
          return api.imageFrom(variant && variant.featured_image) || api.imageFrom(variant && variant.image) ||
            api.imageFrom(skuImage) || api.imageFrom(product.featured_image) ||
            (Array.isArray(product.images) && product.images.length ? api.imageFrom(product.images[0]) : null);
        },

        enhanceLinkedProducts: function (container, row, product) {
          if (!product || row.dataset.jxSrcvidLinkedReady === 'true') return;
          var entries = api.linkedProductEntries(product);
          if (entries.length < 2) return;
          var optionNames = Array.isArray(product.options) ? product.options.map(function (option) {
            return typeof option === 'string' ? option : option.name || '';
          }) : [];
          var colorIndex = optionNames.findIndex(function (name) {
            return /(color|colour|färg|farge|farve|väri)/i.test(String(name));
          });
          if (colorIndex >= 0 && Array.isArray(product.variants) && product.variants.some(function (variant) { return variant.available; })) {
            var colors = {};
            product.variants.forEach(function (variant) {
              var value = api.variantOptions(variant, optionNames.length)[colorIndex];
              if (value) colors[value] = true;
            });
            if (Object.keys(colors).length > 1) return;
          }
          var groupKey = entries.map(function (entry) { return entry.id; }).sort().join('|');
          row.setAttribute('data-jx-srcvid-linked-group', groupKey);
          var groupRows = Array.prototype.slice.call(container.querySelectorAll('.jx-srcvid-recommendations__item')).filter(function (candidate) {
            return candidate.getAttribute('data-jx-srcvid-linked-group') === groupKey;
          });
          if (groupRows[0] !== row) {
            row.remove();
            api.setupSwap(container);
            return;
          }
          row.dataset.jxSrcvidLinkedReady = 'true';
          var preferredId = row.getAttribute('data-jx-srcvid-preferred-variant-id');
          var names = api.linkedColorNames(entries);
          var pendingAction = row.querySelector('[data-jx-srcvid-checkbox], [data-jx-srcvid-add]');
          if (pendingAction && !(product.variants || []).some(function (variant) { return String(variant.id) === preferredId && variant.available; })) {
            pendingAction.disabled = true;
          }
          return Promise.all(entries.map(function (entry) {
            var current = product.variants && product.variants.find(function (variant) { return String(variant.id) === entry.id; });
            if (current) return Promise.resolve({ entry: entry, product: product, variant: current });
            return api.fetchVariant(entry.id).then(function (match) {
              if (match && match.product && entry.title) {
                match = Object.assign({}, match, { product: Object.assign({}, match.product, { title: entry.title }) });
              }
              return api.resolveProductForMatch(match);
            }).then(function (match) {
              var sibling = match && match.fullProduct;
              var variant = sibling && sibling.variants && sibling.variants.find(function (item) { return String(item.id) === entry.id; });
              return sibling && variant ? { entry: entry, product: sibling, variant: variant } : null;
            });
          })).then(function (results) {
            var resolved = results.filter(Boolean);
            if (resolved.length < 2 || !row.isConnected) return;
            var chosen = resolved.find(function (item) { return item.entry.id === preferredId && item.variant.available; }) ||
              resolved.find(function (item) { return item.variant.available; });
            if (!chosen) {
              row.remove();
              api.setupSwap(container);
              return;
            }
            var optionsNode = row.querySelector('[data-jx-srcvid-options]');
            if (!optionsNode) return;
            optionsNode.innerHTML = '';
            var swatches = document.createElement('div');
            swatches.className = 'jx-srcvid-recommendations__swatches';
            var buttons = [];

            function select(item) {
              if (!item || !item.variant.available) return;
              chosen = item;
              row.setAttribute('data-jx-srcvid-product-id', item.product.id);
              row.setAttribute('data-jx-srcvid-product-handle', item.product.handle);
              row.setAttribute('data-jx-srcvid-product-url', item.product.url || api.root() + 'products/' + item.product.handle);
              row.setAttribute('data-jx-srcvid-variant-id', item.variant.id);
              row.setAttribute('data-jx-srcvid-item', item.variant.id);
              var action = row.querySelector('[data-jx-srcvid-checkbox], [data-jx-srcvid-add]');
              if (action) {
                action.disabled = false;
                action.setAttribute('data-variant-id', item.variant.id);
                action.setAttribute('data-product-title', item.product.title);
              }
              var image = api.imageForLinkedProduct(item.product, item.variant);
              var imageLink = row.querySelector('.jx-srcvid-recommendations__image-link');
              if (imageLink && image) {
                var currentImage = imageLink.querySelector('.jx-srcvid-recommendations__image');
                if (!currentImage) {
                  imageLink.innerHTML = '';
                  currentImage = api.makeImage(image, item.product.title);
                  imageLink.appendChild(currentImage);
                }
                currentImage.removeAttribute('srcset');
                currentImage.src = image;
                currentImage.alt = item.product.title;
              }
              var url = (item.product.url || api.root() + 'products/' + item.product.handle).split('?')[0].split('#')[0] + '?variant=' + item.variant.id;
              row.querySelectorAll('.jx-srcvid-recommendations__image-link, .jx-srcvid-recommendations__title').forEach(function (link) {
                link.href = url;
                link.removeAttribute('tabindex');
              });
              var title = row.querySelector('.jx-srcvid-recommendations__title');
              if (title) title.textContent = item.product.title;
              var price = row.querySelector('.jx-srcvid-recommendations__price');
              if (price) price.textContent = api.formatMoney(item.variant.price, container.getAttribute('data-jx-srcvid-money-format'));
              buttons.forEach(function (button) {
                button.node.setAttribute('aria-pressed', String(button.id === item.entry.id));
              });
            }

            entries.forEach(function (entry, index) {
              var item = resolved.find(function (candidate) { return candidate.entry.id === entry.id; });
              if (!item) return;
              var button = document.createElement('button');
              button.type = 'button';
              button.className = 'jx-srcvid-recommendations__swatch';
              button.title = names[index];
              button.setAttribute('aria-label', names[index] + (item.variant.available ? '' : ' - sold out'));
              button.disabled = !item.variant.available;
              var fill = document.createElement('span');
              fill.className = 'jx-srcvid-recommendations__swatch-fill';
              fill.setAttribute('aria-hidden', 'true');
              fill.style.setProperty('--jx-srcvid-swatch-color', api.swatchStyle(row, names[index]).color);
              button.appendChild(fill);
              button.addEventListener('click', function () { select(item); });
              swatches.appendChild(button);
              buttons.push({ node: button, id: entry.id });
            });
            optionsNode.appendChild(swatches);
            select(chosen);
            api.setupSwap(container);
          });
        },

        hydrateLiquidRows: function (container) {
          container.querySelectorAll('.jx-srcvid-recommendations__item').forEach(function (row) {
            var fullProduct = row._jxSrcvidProduct;
            var productJson = row.querySelector('[data-jx-srcvid-product-json]');
            if (!fullProduct && productJson) {
              try {
                fullProduct = JSON.parse(productJson.textContent);
              } catch (error) {}
            }
            if (fullProduct) {
              api.enhanceRowVariants(container, row, fullProduct);
              api.enhanceLinkedProducts(container, row, fullProduct);
              return;
            }
            var placeholder = row.querySelector('.jx-srcvid-recommendations__image-placeholder');
            var img = row.querySelector('img.jx-srcvid-recommendations__image, img');
            var imageLink = row.querySelector('.jx-srcvid-recommendations__image-link');
            var titleLink = row.querySelector('.jx-srcvid-recommendations__title');
            var variantNode = row.querySelector('[data-variant-id]');
            var variantId = row.getAttribute('data-jx-srcvid-variant-id') || row.getAttribute('data-jx-srcvid-item') || (variantNode && variantNode.getAttribute('data-variant-id')) || '';
            var title = (titleLink && titleLink.textContent || row.textContent || '').replace(/\s+/g, ' ').trim();
            var handle = row.getAttribute('data-jx-srcvid-product-handle') || api.handleFromUrl(imageLink && imageLink.getAttribute('href')) || api.handleFromUrl(titleLink && titleLink.getAttribute('href'));
            var needsImage = !!placeholder && !img;
            var needsUrl = !titleLink || !titleLink.getAttribute('href') || titleLink.getAttribute('href') === '#';
            var needsImageUrl = imageLink && (!imageLink.getAttribute('href') || imageLink.getAttribute('href') === '#');

            if (variantId) {
              row.setAttribute('data-jx-srcvid-item', variantId);
              row.setAttribute('data-jx-srcvid-variant-id', variantId);
            }

            function applyProduct(product, productHandle) {
              if (!product && !productHandle) {
                return;
              }
              var url = product && product.url || (productHandle ? api.root() + 'products/' + productHandle : '');
              var resolvedHandle = productHandle || product && product.handle || api.handleFromUrl(url);
              var imageSrc = product && api.imageFromProductJson(product, variantId) || product && (api.imageFrom(product.image) || api.imageFrom(product.featured_image));

              if (resolvedHandle) {
                row.setAttribute('data-jx-srcvid-product-handle', resolvedHandle);
              }
              if (url && url !== '#') {
                row.setAttribute('data-jx-srcvid-product-url', url);
                if (titleLink && needsUrl) {
                  titleLink.setAttribute('href', url);
                  titleLink.removeAttribute('tabindex');
                }
                if (imageLink && needsImageUrl) {
                  imageLink.setAttribute('href', url);
                  imageLink.removeAttribute('tabindex');
                }
              }
              if (imageSrc && needsImage && placeholder && placeholder.parentNode) {
                placeholder.parentNode.replaceChild(api.makeImage(imageSrc, title), placeholder);
              }
              if (product && Array.isArray(product.variants) && product.variants.some(function (variant) { return String(variant.id) === String(variantId); })) {
                api.enhanceRowVariants(container, row, product);
                api.enhanceLinkedProducts(container, row, product);
              }
            }

            if (handle) {
              api.fetchProductByHandle(handle).then(function (product) {
                applyProduct(product, handle);
              });
              return;
            }

            if (needsImage || needsUrl || needsImageUrl) {
              api.searchProductByTitle(title).then(function (suggested) {
                if (!suggested) {
                  return;
                }
                applyProduct({
                  handle: suggested.handle,
                  title: suggested.title,
                  url: suggested.url,
                  image: suggested.image,
                  featured_image: suggested.image,
                  images: suggested.image ? [suggested.image] : []
                }, suggested.handle);
                if (suggested.handle && (needsImage || !suggested.image)) {
                  api.fetchProductByHandle(suggested.handle).then(function (product) {
                    applyProduct(product, suggested.handle);
                  });
                }
              });
            }
          });
        },

        showDebug: function (container, message) {
          var debug = container.querySelector('[data-jx-srcvid-debug]');
          if (!debug) {
            return;
          }
          debug.textContent = message;
          debug.hidden = false;
          container.classList.remove('jx-srcvid-recommendations--pending');
        },
        
          renderSwapPage: function (container, page) {
          var mode = container.getAttribute('data-jx-srcvid-mode') || 'product';

          if (mode !== 'product') {
            return;
          }

          var rows = Array.prototype.slice.call(container.querySelectorAll('.jx-srcvid-recommendations__item'));
          var pageSize = Number(container.getAttribute('data-jx-srcvid-page-size') || 3);
          var totalPages = Math.ceil(rows.length / pageSize);

          if (!rows.length || totalPages <= 1) {
            rows.forEach(function (row) {
              row.hidden = false;
            });

            var singleSwapButton = container.querySelector('[data-jx-srcvid-swap]');
            if (singleSwapButton) {
              singleSwapButton.hidden = true;
            }

            return;
          }

          if (page < 0) {
            page = totalPages - 1;
          }

          if (page >= totalPages) {
            page = 0;
          }

          container.setAttribute('data-jx-srcvid-current-page', page);

          rows.forEach(function (row, index) {
            var isVisible = index >= page * pageSize && index < (page + 1) * pageSize;

            row.hidden = !isVisible;

            if (!isVisible) {
              var checkbox = row.querySelector('[data-jx-srcvid-checkbox]');
              if (checkbox) {
                checkbox.checked = false;
              }
            }
          });
        },

        setupSwap: function (container) {
          var mode = container.getAttribute('data-jx-srcvid-mode') || 'product';

          if (mode !== 'product') {
            return;
          }

          var rows = Array.prototype.slice.call(container.querySelectorAll('.jx-srcvid-recommendations__item'));
          var pageSize = Number(container.getAttribute('data-jx-srcvid-page-size') || 3);
          var swapButton = container.querySelector('[data-jx-srcvid-swap]');

          if (!swapButton) {
            return;
          }

          if (rows.length <= pageSize) {
            swapButton.hidden = true;

            rows.forEach(function (row) {
              row.hidden = false;
            });

            return;
          }

          swapButton.hidden = false;

          if (swapButton.dataset.jxSrcvidSwapReady !== 'true') {
            swapButton.dataset.jxSrcvidSwapReady = 'true';

            swapButton.addEventListener('click', function () {
              var currentPage = Number(container.getAttribute('data-jx-srcvid-current-page') || 0);
              api.renderSwapPage(container, currentPage + 1);
            });
          }

          api.renderSwapPage(container, Number(container.getAttribute('data-jx-srcvid-current-page') || 0));
        },
        
        resolveProductForMatch: function (match) {
          if (!match || !match.variant) {
            return Promise.resolve(match);
          }
          var variantId = String(match.variant.id);
          var handle = api.handleFromUrl(match.product && match.product.url);
          if (handle) {
            return api.fetchProductByHandle(handle).then(function (product) {
              if (product && Array.isArray(product.variants) && product.variants.some(function (variant) { return String(variant.id) === variantId; })) {
                match.fullProduct = product;
                match.product.url = product.url;
                match.product.title = product.title;
              }
              return match;
            });
          }
          return fetch(api.searchSuggestUrl(match.product.title), { credentials: 'same-origin' })
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (json) {
              var candidates = json && json.resources && json.resources.results && json.resources.results.products || [];
              var handles = candidates.map(function (candidate) { return candidate.handle || api.handleFromUrl(candidate.url); }).filter(Boolean);
              return Promise.all(handles.map(api.fetchProductByHandle)).then(function (products) {
                var product = products.find(function (candidate) {
                  return candidate && Array.isArray(candidate.variants) && candidate.variants.some(function (variant) { return String(variant.id) === variantId; });
                });
                if (product) {
                  match.fullProduct = product;
                  match.product.url = product.url;
                  match.product.title = product.title;
                }
                return match;
              });
            })
            .catch(function () { return match; });
        },
        populateFromVariantIds: function (container) {
          var list = container.querySelector('[data-jx-srcvid-list]');
          var limit = Number(container.getAttribute('data-jx-srcvid-limit') || 3);
          var variantIds = String(container.getAttribute('data-jx-srcvid-variant-ids') || '').split('|').map(function (id) { return id.trim(); }).filter(Boolean);
          var excludedVariantIds = container.getAttribute('data-jx-srcvid-excluded-variant-ids') || '';
          var mode = container.getAttribute('data-jx-srcvid-mode') || 'product';
          var renderedVariantIds = {};
          var renderedProductIds = {};
          var matches = [];
          var existingRows = Array.prototype.slice.call(list.querySelectorAll('[data-jx-srcvid-item]'));
          existingRows.forEach(function (row) {
            var preferredId = row.getAttribute('data-jx-srcvid-preferred-variant-id') || row.getAttribute('data-jx-srcvid-variant-id');
            var productId = row.getAttribute('data-jx-srcvid-product-id');
            if (preferredId) renderedVariantIds[preferredId] = true;
            if (productId) renderedProductIds[productId] = true;
          });
          if (existingRows.length) {
            container.classList.remove('jx-srcvid-recommendations--pending');
            api.hydrateLiquidRows(container);
            api.setupSwap(container);
          }

          var pendingIds = [];
          variantIds.forEach(function (variantId) {
            if (existingRows.length + pendingIds.length >= limit) {
              return;
            }
            if (mode === 'product' && excludedVariantIds.indexOf('|' + variantId + '|') !== -1) {
              return;
            }
            if (renderedVariantIds[variantId]) {
              return;
            }
            renderedVariantIds[variantId] = true;
            pendingIds.push(variantId);
          });

          function acceptMatch(match) {
            if (!match || !match.variant) {
              return;
            }
            if (existingRows.length + matches.length >= limit) {
              return;
            }
            var product = match.fullProduct;
            if (product) {
              if ((!product.variants.some(function (variant) { return variant.available; }) && api.linkedProductEntries(product).length < 2) || renderedProductIds[String(product.id)]) {
                return;
              }
              renderedProductIds[String(product.id)] = true;
            } else if (match.variant.available === false) {
              return;
            }
            matches.push(match);
          }

          var pending = pendingIds.length
            ? Promise.all(pendingIds.map(function (variantId) {
              return api.fetchVariant(variantId).then(api.resolveProductForMatch).then(function (match) {
                return match;
              }).catch(function () {
                return null;
              });
            }))
            : Promise.resolve([]);

          return pending.then(function (results) {
            results.forEach(acceptMatch);
            if (!matches.length && !existingRows.length) {
              if (window.Shopify && Shopify.designMode) {
                api.showDebug(container, 'SrcVID found these variant IDs: ' + variantIds.join(', ') + '. No matching online variant was found by Liquid or /variants/{id}.js. Check that the IDs are variant IDs, not product IDs, and that those variants are published to Online Store.');
              }
              return;
            }
            matches.forEach(function (match, index) {
              list.appendChild(api.renderRow(container, match, existingRows.length + index));
            });
            Array.prototype.slice.call(list.querySelectorAll('.jx-srcvid-recommendations__item')).sort(function (left, right) {
              var leftId = left.getAttribute('data-jx-srcvid-preferred-variant-id') || left.getAttribute('data-jx-srcvid-variant-id');
              var rightId = right.getAttribute('data-jx-srcvid-preferred-variant-id') || right.getAttribute('data-jx-srcvid-variant-id');
              return variantIds.indexOf(leftId) - variantIds.indexOf(rightId);
            }).forEach(function (row) { list.appendChild(row); });
            
            container.classList.remove('jx-srcvid-recommendations--pending');
            api.hydrateLiquidRows(container);
            api.setupSwap(container);
            
            document.dispatchEvent(new CustomEvent('lh:srcsku-recommendations-ready', {
              
              bubbles: true,
              detail: {
                container: container
              }
            }));
          });
        },

        serializeMainItem: function (form) {
          var formData = new FormData(form);
          var item = {
            id: Number(formData.get('id')),
            quantity: Number(formData.get('quantity') || 1)
          };

          var sellingPlan = formData.get('selling_plan');
          if (sellingPlan) {
            item.selling_plan = sellingPlan;
          }

          var properties = {};
          formData.forEach(function (value, key) {
            var match = key.match(/^properties\[(.+)\]$/);
            if (match && value !== '') {
              properties[match[1]] = value;
            }
          });

          if (Object.keys(properties).length) {
            item.properties = properties;
          }

          return item;
        },

        addItems: function (items) {
          return fetch(api.getCartAddUrl(), {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: items })
          }).then(function (response) {
            if (!response.ok) {
              throw new Error('SrcVID add to cart failed');
            }
            return response.json();
          });
        },

        emitProductAdded: function (origin, quantity) {
          var target = origin || document.documentElement;
          target.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              button: origin && origin.tagName === 'BUTTON' ? origin : null,
              variant: null,
              quantity: quantity
            }
          }));
        },

        init: function (root) {
          root = root || document;
          root.querySelectorAll('[data-jx-srcvid-recommendations]').forEach(function (element) {
            if (element.dataset.jxSrcvidInitialized === 'true') {
              return;
            }
            element.dataset.jxSrcvidInitialized = 'true';
            api.populateFromVariantIds(element);
          });
          api.attachHeaderRerenderListeners();
          api.startObserver();
        },

        attachHeaderRerenderListeners: function () {
          document.querySelectorAll('[data-section-type="header"]').forEach(function (header) {
            if (header.dataset.jxSrcvidCartListener === 'true') {
              return;
            }
            header.dataset.jxSrcvidCartListener = 'true';
            header.addEventListener('cart:rerendered', function () {
              api.init(header);
            });
          });
        },

        startObserver: function () {
          if (api.observerStarted || !document.body || !window.MutationObserver) {
            return;
          }
          api.observerStarted = true;
          var observer = new MutationObserver(function () {
            clearTimeout(api.observerTimer);
            api.observerTimer = setTimeout(function () {
              api.init(document);
            }, 60);
          });
          observer.observe(document.body, { childList: true, subtree: true });
        }
      };

      window.JXSrcVidRecommendations = api;
      window.JX_SRCVID_VERSION = api.version;
      window.JX_SRCVID_COPY_DEBUG = function () { return api.copyDebug(document); };

      document.addEventListener('click', function (event) {
        var quickAddButton = event.target.closest('[data-jx-srcvid-add]');
        if (!quickAddButton) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        var variantId = Number(quickAddButton.getAttribute('data-variant-id'));
        if (!variantId) {
          return;
        }

        quickAddButton.disabled = true;
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        api.addItems([{ id: variantId, quantity: 1 }])
          .then(function () {
            api.emitProductAdded(quickAddButton, 1);
          })
          .catch(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
          })
          .finally(function () {
            quickAddButton.disabled = false;
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          });
      });

      document.addEventListener('click', function (event) {
        var button = event.target.closest('[data-action="add-to-cart"]');
        if (!button) {
          return;
        }

        var productFormElement = button.closest('product-form');
        if (!productFormElement) {
          return;
        }

        var recommendationBlock = productFormElement.querySelector('[data-jx-srcvid-recommendations][data-jx-srcvid-mode="product"]');
        if (!recommendationBlock) {
          return;
        }

        var checkedBoxes = Array.prototype.slice.call(recommendationBlock.querySelectorAll('[data-jx-srcvid-checkbox]:checked:not(:disabled)'));
        if (!checkedBoxes.length) {
          return;
        }

        var mainForm = productFormElement.querySelector('form[action*="/cart/add"]');
        if (!mainForm || (mainForm.reportValidity && !mainForm.reportValidity())) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var items = [api.serializeMainItem(mainForm)];
        checkedBoxes.forEach(function (checkbox) {
          var variantId = Number(checkbox.getAttribute('data-variant-id'));
          if (variantId) {
            items.push({ id: variantId, quantity: 1 });
          }
        });

        var totalQuantity = items.reduce(function (total, item) {
          return total + Number(item.quantity || 1);
        }, 0);

        button.disabled = true;
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        api.addItems(items)
          .then(function () {
            api.emitProductAdded(productFormElement, totalQuantity);
          })
          .catch(function () {
            mainForm.submit();
          })
          .finally(function () {
            button.disabled = false;
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          });
      }, true);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { api.init(document); });
      } else {
        api.init(document);
      }

      document.addEventListener('shopify:section:load', function (event) {
        api.init(event.target || document);
      });
    })();